// Copyright (c) Move Closer 2022.

import { MappingConfig } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const productAdapterMap: MappingConfig = {
  category: 'category',
  createdAt: 'createdAt',
  id: 'id',
  meta: 'meta',
  specification: 'specification',
  updatedAt: 'updatedAt',
  urlPath: 'urlPath',
  sku: 'sku',
  variants: 'variants',
  variantSelector: 'variantSelector'
}
